import React from "react";

import CloseIcon from "../../../../assets/images/close-icon.svg";
import SubtractionIcon from "../../../../assets/images/nav-subtraction.svg";
import { getTranslation } from "../../../../helpers/getLanguage";
import SubtractionTabs from "./SubtractionTabs";

const SubtractionModalHeader = ({
  closeDialog,
  subtraction,
  currentTab,
  isCompletedIdea,
  productType,
  getSubtractionHeader,
  changeCurrentTab,
}) => {
  const getCurrentProductType = () => {
    switch (productType) {
      case "process":
        return getTranslation("PRODUCT_TYPE_PROCESS");
      case "service":
        return getTranslation("PRODUCT_TYPE_SERVICE");
      default:
        return getTranslation("PRODUCT_TYPE_PRODUCT");
    }
  };

  const tabsLabels = [
    <span style={{ color: "inherit" }}>
      {`${getTranslation("SUBTRACTION_TAB_DESCRIBE_NEW_PRODUCT")} ${getCurrentProductType()}`}
    </span>,
    <span style={{ color: "inherit" }}>{getTranslation("SUBTRACTION_MODAL_TABS_LIST_BENEFITS")}</span>,
    <span style={{ color: "inherit" }}>{getTranslation("IDEA_MODAL_TABS_LIST_IMPLEMENTATION_CHALLENGES")}</span>,
  ];

  return (
    <div className="subtraction-modal-header flex-column">
      <div className="subtraction-modal-title-container flex mb-20">
        <div className="flex align-center">
          <img className="subtraction-modal-header-icon" src={SubtractionIcon} alt="" />
          <div>
            <span className="subtraction-modal-title">{getTranslation("MODAL_TITLE_SUBTRACTION")}</span>
          </div>
        </div>

        <div className="flex align-center subtraction-modal-controls">
          <img src={CloseIcon} alt="" className="pointer" onClick={closeDialog} />
        </div>
      </div>

      <div className="flex-center">{getSubtractionHeader()}</div>

      <SubtractionTabs
        currentTab={currentTab}
        subtraction={subtraction}
        labels={tabsLabels}
        isCompletedIdea={isCompletedIdea}
        changeCurrentTab={changeCurrentTab}
      />
    </div>
  );
};

export default SubtractionModalHeader;
